export default function SetSelectedRuleWarning(value: string): void {
  sessionStorage.setItem("selectedRuleWarning", value);
}
